import React from 'react';
import ReactDOM from 'react-dom';
import RailLoadingApp from './RailLoadingApp';

import './branding.scss';

ReactDOM.render(<RailLoadingApp />, document.getElementById('root'));
